import {createURL} from "./client";
import axios from "axios";

/**
 * claimDailyBonus запрашивает ежедневный бонус для игрока
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export async function claimDailyBonus() {
    return await axios.post(createURL("/api/bonus/claim"));
}
